// extracted by mini-css-extract-plugin
module.exports = {"container":"cookies_container__hx8dw","link":"cookies_link__NEIkc","form":"cookies_form__8ltb7"};